import type { ReactNode } from 'react';
import Tooltip from '@/components/Tooltip';
import { Heading, Grid } from '@simplywallst/ui-core';
import { Table, Term, TooltipTitle } from './styled';
import ColumnKeyMetrics from './components/ColumnKeyMetrics';
import RowKeyMetrics from './components/RowKeyMetrics';

interface KeyMetrics {
  title: string;
  value: string;
  tooltip?: string | null;
}

interface Metrics {
  title: string;
  value: ReactNode;
  tooltip?: string | null;
}

interface Props {
  keyMetrics?: [KeyMetrics] | [KeyMetrics, KeyMetrics];
  metrics?: Metrics[];
  direction?: 'column' | 'row';
  heading?: ReactNode;
}
const KeyInformation = ({
  keyMetrics,
  metrics,
  direction = 'row',
  heading = (
    <Heading as="h3" typography="small">
      Key information
    </Heading>
  ),
}: Props) => {
  return (
    <Grid
      data-cy-id="key-information"
      backgroundColor="phantom"
      borderRadius="x1"
      padding="x2"
      width="100%"
      height="100%"
      gap="16px"
    >
      {heading}
      {direction === 'column' ? (
        <ColumnKeyMetrics keyMetrics={keyMetrics} />
      ) : (
        <RowKeyMetrics keyMetrics={keyMetrics} />
      )}
      {metrics && (
        <Table>
          <tbody>
            {metrics.map((metric, i) => (
              <tr key={i}>
                <td>
                  {typeof metric.tooltip !== 'undefined' ? (
                    <Tooltip
                      title={<TooltipTitle>{metric.tooltip}</TooltipTitle>}
                      light
                      openDelay={300}
                    >
                      <Term>{metric.title}</Term>
                    </Tooltip>
                  ) : (
                    metric.title
                  )}
                </td>
                <td>{metric.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Grid>
  );
};

export default KeyInformation;
